// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mobileCampaigns___wrapper___1b0Jk"};